import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e4ba7e44"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e4ba7e44&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ba7e44')) {
      api.createRecord('e4ba7e44', component.options)
    } else {
      api.reload('e4ba7e44', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e4ba7e44", function () {
      api.rerender('e4ba7e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/index.vue"
export default component.exports